import { Person, StringType } from "../types";

export const getPersonFullName = (id: string | undefined, persons: Person[]) => {
  if (!id) return 'Unknown';
  const person = persons.find(p => p.id === id);
  return person ? `${person.firstName} ${person.lastName}` : 'Unknown';
};

export function getStringName(id: string, stringTypes: StringType[]): string {
  const s = stringTypes.find(st => st.id === id);
  if (!s) return 'Unknown';
  const label = `${s.brand || ''} ${s.name}`.trim();
  return s.gauge ? `${label} ${s.gauge}` : label;
}
